<template>
  <transition name="slide">
    <div class="hs-container-child" v-if="currentValue">

      <!--搜索框 start-->
      <hs-search-bar
        type="style1"
        :placeholder="$t('KeywordSearch_1')"
        v-model.trim="KeyWord"
        @cancel="_close"
        @keyupEnter="_keyupEnter"
        @clear="_clear"
      />
      <!--搜索框 start-->
      <div class="header" v-if="KeyWord" :style="SearchDesc && SearchDesc.length > 18 ? {fontSize: '12px'} : ''">{{SearchDesc || $t('QueryResultOfTheCurrentCity')}}</div>

      <div class="header header-fixed" v-if="KeyWord && showFixedHeader" :style="otherSearchDesc && otherSearchDesc.length > 18 ? {fontSize: '12px'} : ''">{{otherSearchDesc}}</div>

      <hs-scroll
        class="table-view"
        :style="{height: `calc(100% - 50px - ${KeyWord ? '36px' : 0})`}"
        :data="[details]"
        :isListenScroll="true"
        @scroll="_mixinScroll"
      >
        <ul class="scroll-box">
          <template v-if="KeyWord">
            <search-list v-if="!(searchList.length <= 0 && otherSearchList.length > 0)" :KeyWord="KeyWord" :datalist="searchList" @select="_updateDetails" />
            <template v-if="otherSearchList.length > 0">
              <div ref="otherHeader" class="header" v-if="KeyWord" :style="otherSearchDesc && otherSearchDesc.length > 18 ? {fontSize: '12px'} : ''">{{otherSearchDesc}}</div>
              <search-list :KeyWord="KeyWord" :datalist="otherSearchList" @select="_updateDetails" />
            </template>
          </template>
          <template v-else>
            <business-card
                v-if="history.Conditions && history.Conditions.length > 0"
                key="history"
                :details="history"
                :title="history.TypeName"
                :datalist="history.Conditions"
                @select="_updateDetails"
                @clearHistory="_clearHistory" />
            <template v-for="(item, index) in currentDetails">
              <business-card
                  v-if="
                  item.Conditions &&
                  item.Conditions.length > 0 &&
                  getNotHasChildren(item.Conditions)
                "
                  :key="`${item.CityId}${item.Type}${index}`"
                  :details="item"
                  :selectedKey="index"
                  :title="item.TypeName"
                  :datalist="item.Conditions"
                  @select="_updateDetails" />
            </template>
          </template>
        </ul>
      </hs-scroll>
    </div>
  </transition>
</template>
<script type="text/ecmascript-6">
import HsScroll from 'base/hs-scroll/hs-scroll'
import HsSection from 'base/hs-tableview/hs-section/hs-section'
import HsCell1 from 'base/hs-tableview/hs-cell-1/hs-cell-1'
import {cloneObject} from '../../../common/utility/utils';
import {kpiIntlHotelGetIntlHotelCityByKeyword} from 'api'
import {kpiHotelGetHotelSearchEngine} from 'api/hotel/hotelApi'
import mixinFilterHotelHome from "@/common/mixin/hotel/mixin-filter-hotel-home";
import {HOTEL_FILTER_V, INTL_HOTEL_FILTER_V} from "@/common/constants/common";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    details: {
      type: Array,
      default: function() {
        return []
      }
    },
    searchText: {
      type: Object,
      default: () => {
        return {}
      }
    },
    dHotelOrder: {
      type: Object,
      default: function() {
        return {}
      }
    },
    iHotelOrder: {
      type: Object,
      default: function() {
        return {}
      }
    },
    OrderBusinessType: { // 默认国内酒店
      type: Number,
      default: function() {
        return 2
      }
    },
    IsOaSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      KeyWord: '',
      history: {
        Type: 'history',
        TypeName: this.$t('History'),
        Conditions: []
      },
      SearchDesc: '',
      searchList: [
        // {
        //   hotelName: '汉庭酒店（上海陆家嘴东方路店）',
        //   address: '东方路185号宏汇国际'
        // },
      ],

      otherSearchDesc: '',
      otherSearchList: [],
      currentDetailsTitle: {},
      timer: null,

      showFixedHeader: false,
    }
  },
  mixins:[mixinFilterHotelHome],
  computed: {
    currentValue: {
      get: function() {
        return this.show
      },
      set: function(val) {
        return this.$emit('update:show', false)
      }
    },
    CityVersion() {
      return window.localStorage.CityVersion ? JSON.parse(window.localStorage.CityVersion) : {}
    },
    currentDetails() {
      if (this.OrderBusinessType === 11) { // 国际酒店
        return this.interHotelFilters
      } else {
        return this.hotelFilters
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        console.log('打开弹窗------------', this.details)
        this.KeyWord = this.searchText.Name || ''
        this.SearchDesc = ''
        this._gotoClearHistory();
        this._getHotelHistorySelects()

        // 获取城市下的酒店筛选条件
        if (this.OrderBusinessType === 11) { // 国际酒店
          this.getInterHotelFilters({cityID: this.dHotelOrder.CityID})
        } else {
          this.getHotelFilters({CityId: this.dHotelOrder.CityID || ''})
        }
      }
    },
    KeyWord(value, oldValue) {
      if (value !== oldValue) {
        this._sendAjax()
      }
    }
  },
  methods: {
    _close() {
      this.currentValue = false
    },

    // 滚动监听
    _mixinScroll(pos) {
      let offsetTop = this.$refs.otherHeader && this.$refs.otherHeader.offsetTop
      if (-pos.y >= offsetTop) {
        this.showFixedHeader = true
      } else {
        this.showFixedHeader = false
      }
    },

    // 清空输入框内容
    _clear() {
      this.KeyWord = ''
      // this.$emit('updateFilterDetails', this._updateSelected(), {}, '')
    },

    // 根据城市版本号 判断 是否需要清空历史记录
    _gotoClearHistory() {
      // 根据城市版本号 清空历史
      let version = window.localStorage[INTL_HOTEL_FILTER_V]
      let IntlHotelCityVersionV2 = this.CityVersion.IntlHotelCityVersionV2
      if (!version || !IntlHotelCityVersionV2 || version !== IntlHotelCityVersionV2) {
        window.localStorage.INTER_HOTEL_FILTERS_HISTORY_SELECTS = '[]'
      }

      // 国内酒店
      let hotelVersion = window.localStorage[HOTEL_FILTER_V]
      let HotelCityVersion = this.CityVersion.HotelCityVersion
      if (!hotelVersion || !HotelCityVersion || hotelVersion !== HotelCityVersion) {
        window.localStorage.HOTEL_FILTERS_HISTORY_SELECTS = '[]'
      }
    },

    /** 清空历史记录 */
    _clearHistory() {
      if (this.OrderBusinessType === 11) { // 国际酒店
        window.localStorage.INTER_HOTEL_FILTERS_HISTORY_SELECTS = []
      } else {
        window.localStorage.HOTEL_FILTERS_HISTORY_SELECTS = []
      }
      this.history.Conditions = []
    },

    // 键盘确认键点击事件
    _keyupEnter() {
      console.log('键盘确认键点击触发')
      this._close()
      // let item = this._getFilterItem() || {
      //   Id: null,
      //   Latitude: null,
      //   Longitude: null,
      //   Name: this.KeyWord,
      //   CityID: '',
      //   Type: '',
      //   FilterType: '',
      //   selected: false
      // }
      let item = {
        Id: null,
        Latitude: null,
        Longitude: null,
        Name: this.KeyWord,
        CityID: this.dHotelOrder.CityID,
        Type: 'other',
        FilterType: '',
        selected: false
      }
      this.$emit('updateFilterDetails', this._updateSelected(item), cloneObject(item), '')
      this._setHotelHistorySelects(item)
    },

    // 根据 KeyWord 匹配搜索结果和基础筛选条件
    _getFilterItem() {
      let {searchList, currentDetails} = this
      return this._listMap(searchList) ? this._listMap(searchList) : this._currentDetailsFilterItem(currentDetails)
    },

    _currentDetailsFilterItem(list) {
      let item = null
      for (let i = 0, len = list.length; i < len; i++) {
        let Conditions = list[i].Conditions || []
        if (Conditions && Conditions.length > 0) {
          item = this._listMap(Conditions)
          if (item && item.Id) {
            break
          }
        }
      }
      return item
    },

    _listMap(list) {
      let item = null
      for (let i = 0, len = list.length; i < len; i++) {
        if (list[i].Name === this.KeyWord) {
          item = cloneObject(list[i])
          break
        }
      }
      return item
    },

    /** 防抖 300ms */
    _sendAjax() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        if (this.OrderBusinessType === 2) {
          this._kpiHotelGetHotelSearchEngine()
        } else {
          this._getInterHotelSearch()
        }
      }, 500)
    },

    // 获取国际酒店列表
    _getInterHotelSearch() {
      let {CityID, Latitude, Longitude} = this.dHotelOrder
      this.searchList = []
      kpiIntlHotelGetIntlHotelCityByKeyword({
        CityId: CityID || '',
        Keyword: this.KeyWord,
        IsOaSearch: this.IsOaSearch || false,
        SearchType: 1, // 查询入口 城市 0 关键词 1
        Latitude,
        Longitude
      }).then(res => {
        if (res.IsSuccess) {
          this.SearchDesc = res.ResultData.CurrentCitySearchDesc || ''
          let list = res.ResultData && res.ResultData.CurrentCityResults ? res.ResultData.CurrentCityResults : []
          list = list.filter(v => v.CityId)
          this.searchList = list.map(m => {
            return {
              ...m,
              CityCode: m.CityId,
              CityName_CN: m.CityName,
              CityName_EN: m.CityName_EN,
              CityName_JP: m.CityName_JP,
              CountryName_CN: m.CountryName,
              CityID: m.CityId
            }
          })

          this.otherSearchDesc = res.ResultData.OtherCitySearchDesc || ''
          let otherList = res.ResultData && res.ResultData.OtherCityResults ? res.ResultData.OtherCityResults : []
          this.otherSearchList = otherList.map(m => {
            return {
              ...m,
              CityCode: m.CityId,
              CityName_CN: m.CityName,
              CityName_EN: m.CityName_EN,
              CityName_JP: m.CityName_JP,
              CountryName_CN: m.CountryName,
              CityID: m.CityId
            }
          })
        }
      })
    },

    /** 酒店关键词搜索 */
    _kpiHotelGetHotelSearchEngine() {
      let {CityID, Latitude, Longitude} = this.dHotelOrder
      this.searchList = []
      this.SearchDesc = ''
      kpiHotelGetHotelSearchEngine({
        CityId: CityID || '',
        Keyword: this.KeyWord,
        IsOaSearch: this.IsOaSearch || false,
        SearchType: 1, // 查询入口 城市 0 关键词 1
        Latitude,
        Longitude
      }).then(res => {
        if (res.IsSuccess) {
          this.SearchDesc = res.ResultData.SearchDesc || ''
          let list = res.ResultData && res.ResultData.HotelSearchResultDTOs ? res.ResultData.HotelSearchResultDTOs : []
          list = list.filter(v => v.CityId)
          this.searchList = list.map(m => {
            return {
              ...m,
              CityCode: m.CityId,
              CityName_CN: m.CityName,
              CityName_EN: m.CityName_EN,
              CityName_JP: m.CityName_JP,
              CityID: m.CityId
            }
          })
        }
      })
    },

    /** 选中后更新数据 */
    _updateDetails(item, key) {
      this._close()
      this.$emit('updateFilterDetails', this._updateSelected(item), cloneObject(item), key)
      this._setHotelHistorySelects(item)
    },

    // 更新选中项
    _updateSelected(item = {}) {
      let list = cloneObject(this.currentDetails)
      return list.map(m => {
        if (m.Type === item.Type) {
          return {
            ...m,
            Conditions: m.Conditions.map(n => {
              if (n.Type === 'other') {
                if (n.Name === item.Name) {
                  return {
                    ...n,
                    selected: true
                  }
                }
              } else {
                if (n.Id === item.Id) {
                  return {
                    ...n,
                    selected: true
                  }
                }
              }
              return {
                ...n,
                selected: false
              }
            })
          }
        }
        return {
          ...m,
          Conditions: m.Conditions.map(n => {
            return {
              ...n,
              selected: false
            }
          })
        }
      })
    },

    /** 校验是否是相同城市 */
    _checkIsSameCity(CityID1, CityID2) {
      return String(CityID1) === String(CityID2)
    },

    // 获取选中的历史纪录
    _getHotelHistorySelects() {
      this.history.Conditions = []
      if (this.OrderBusinessType === 11) { // 国际酒店
        let obj = window.localStorage.INTER_HOTEL_FILTERS_HISTORY_SELECTS
        if (!this.noValue(obj)) {
          let list = JSON.parse(obj)
          this.history.Conditions = list.filter(m => this._checkIsSameCity(m.CityID, this.dHotelOrder.CityID))
        }
      } else {
        let obj = window.localStorage.HOTEL_FILTERS_HISTORY_SELECTS
        if (!this.noValue(obj)) {
          let list = JSON.parse(obj)
          this.history.Conditions = list.filter(m => this._checkIsSameCity(m.CityID, this.dHotelOrder.CityID))
        }
      }
    },

    // 设置历史选中记录
    _setHotelHistorySelects(item) {
      if (!item.Name) {
        return
      }
      let Conditions = this.history.Conditions
      let len = 6
      let index = -1
      if (!item.Id && item.Type === 'other') {
        index = Conditions.findIndex(m => m.Id === item.Id && m.Type === item.Type && m.Name === item.Name)
      } else {
        index = Conditions.findIndex(m => m.Id === item.Id && m.Type === item.Type)
      }
      if (index >= 0) {
        Conditions.splice(index, 1)
      }
      Conditions.unshift(item)
      if (Conditions.length > len) {
        Conditions = Conditions.slice(0, len)
      }
      this.history.Conditions = Conditions
      if (this.OrderBusinessType === 11) { // 国际酒店
        window.localStorage.INTER_HOTEL_FILTERS_HISTORY_SELECTS = this._getNewHistoryList(window.localStorage.INTER_HOTEL_FILTERS_HISTORY_SELECTS, Conditions)
        window.localStorage[INTL_HOTEL_FILTER_V] = this.CityVersion.IntlHotelCityVersionV2
      } else {
        window.localStorage.HOTEL_FILTERS_HISTORY_SELECTS = this._getNewHistoryList(window.localStorage.HOTEL_FILTERS_HISTORY_SELECTS, Conditions)
        window.localStorage[HOTEL_FILTER_V] = this.CityVersion.HotelCityVersion
      }
    },

    _getNewHistoryList(obj = null, Conditions) {
      let list = []
      let len = 50
      if (obj) {
        list = JSON.parse(obj)
      }
      let newList = []
      list.map(m => {
        if (Conditions.findIndex(n => this._checkIsSameCity(m.CityID, n.CityID)) < 0) {
          newList.push({
            ...m
          })
        }
      })
      list = [
        ...newList,
        ...Conditions
      ]
      if (list.length > len) {
        list = list.slice(0, len)
      }
      return JSON.stringify(list)
    },

    /** 是否有子集 则不展示 */
    getNotHasChildren(list) {
      return (list || []).findIndex(v => v.Conditions && v.Conditions.length > 0) < 0
    }
  },
  components: {
    HsSearchBar: () => import('base/hs-search-bar/hs-search-bar.vue'),
    BusinessCard: () => import('./business-card'),
    SearchList: () => import('./search-list'),
    HsScroll,
    HsSection,
    HsCell1
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.hs-container-child
  position absolute
  width 100%
  height 100%
  top 0
  left 0
  background-color $color_white
  z-index 99
  .header
    @extend .flex-start
    ellipsis(2);
    height 36px
    padding 10px
    background $color_background_gray_3
  .header-fixed{
    position absolute
    top 86px
    left 0
    width 100%
    z-index 1
  }
  .table-view
    width 100%
    height calc(100% - 50px)
    overflow hidden
  .scroll-box
    padding-bottom 30px
</style>
